module.exports = __webpack_public_path__ + "img/7.98867a49.png";